<!-- 整体框架 -->
<template>
  <div id="app">
    <van-config-provider :theme-vars="themeVars">
      <van-tabbar v-model="activeTab" route v-if="showTabBar">
        <van-tabbar-item icon="home-o" to="/river">河道信息</van-tabbar-item>
        <van-tabbar-item icon="newspaper-o" to="/news">新闻动态</van-tabbar-item>
        <van-tabbar-item icon="comment-o" to="/complaint-summary">投诉建议</van-tabbar-item>
        <van-tabbar-item icon="user-o" to="/profile">个人中心</van-tabbar-item>
      </van-tabbar>

      <!-- 使用keep-alive缓存tabbar页面 -->
      <keep-alive>
        <router-view v-if="$route.meta && $route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
    </van-config-provider>
  </div>
</template>

<script>
import { post, get } from '@/utils/api'
import { appOrPC, ipType, interface_pubkey1, interface_prikey1, app_key } from '@/utils/config'
export default {
  name: 'App',
  data() {
    return {
      activeTab: 0,
      themeVars: {
        tabbarHeight: '50px',
        tabbarItemFontSize: '12px',
        tabbarItemTextColor: '#646566',
        tabbarItemActiveColor: '#1989fa'
      },
      loading: false,
      userInfo: {}
    }
  },
  computed: {
    showTabBar() {
      return !this.$route.meta?.hideTabBar
    }
  },
  methods: {
    async autoLogin(account) {
      console.log("开始执行autoLogin方法");
      const loginKey = 'qtwmxwgd8brlp3j9hf250v60rm18h7rd'
      localStorage.clear()
      this.loading = true
      try {
        if (appOrPC) {
          let that = this
          vaildInterfacefn(
            "hhwzzcsesonq",
            "rcshhwtyjksc",
            SM.encrypt(JSON.stringify({
              ipType: ipType,
              methodType: "post",
              methodName: "api/app/passport/loginAuth",
              // account: "18000000003"
              account: account
            }), interface_pubkey1),
          ).then((value) => {
            if (value == false) {
              return;
            } else {
              try {
                const de_value = JSON.parse(SM.decrypt(value, interface_prikey1))
                console.log('登录接口返回-解密:', de_value)
                if (de_value.code == 200 && de_value.success) {
                  localStorage.setItem('token', de_value.data)
                  console.log('登录成功，开始获取用户信息...')
                  that.getLoginUser()
                } else {
                  that.$dialog.alert({
                    type: 'danger',
                    message: "对不起，您没有权限访问此应用，请联系荣成河湖湾长制管理员获取访问权限。",
                    // message: de_value.message,
                    // confirmButtonText: '确认'
                  }).then(() => {
                    // this.$router.go(-1)
                    // oncloseWindow()
                    lightAppJssdk.navigation.close({
                      success: function (data) {
                        //成功回调
                      }, fail: function (data) {
                        //错误返回
                      }
                    });
                  })
                }
              } catch (error) {
                console.error("autoLogin方法中try-catch error：", error)
                this.autoLogin(account)
              }
            }
          })
        } else {
          const date = new Date().format("yyyyMMddhhmmss")
          const loginToken = this.$md5(`${loginKey}&${account}&${date}`)
          const params = {
            account: account,
            loginToken: loginToken,
            deviceVersion: 'v2.0.0',
            devicePlatform: 'android'
          }
          const res = await post('/passport/loginAuth', params)
          if (res.code == 200 && res.success) {
            localStorage.setItem('token', res.data)
            console.log('登录成功，开始获取用户信息...')
            this.getLoginUser()
          }
        }
      } catch (error) {
        console.error("error:", error)
        if (appOrPC) {
          // 未登录调用爱山东api关闭当前应用
          this.$dialog.alert({
            type: 'danger',
            // message: "对不起，您没有权限访问此应用，请联系荣成河湖湾长制管理员获取访问权限。",
            message: error.message,
            // confirmButtonText: '确认'
          }).then(() => {
            // this.$router.go(-1)
            // oncloseWindow()
            lightAppJssdk.navigation.close({
              success: function (data) {
                //成功回调
              }, fail: function (data) {
                //错误返回
              }
            });
          })
        } else {
          this.$toast.fail(error.message || '自动登录失败')
        }
      } finally {
        this.loading = false
      }
    },
    async getLoginUser() {
      console.log("开始执行getLoginUser方法");
      try {
        if (appOrPC) {
          let that = this, extraData = {
            header: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "App-Version-Code": "v2.0.0"
            }
          }
          vaildInterfacefn(
            "hhwzzcsesonq",
            "rcshhwtyjksc",
            SM.encrypt(JSON.stringify({
              ipType: ipType,
              methodType: "get",
              methodName: "api/app/passport/getLoginUser",
              test: "??"
            }), interface_pubkey1),
            "1",
            extraData
          ).then((value) => {
            if (value == false) {
              return;
            } else {
              try {
                const de_value = JSON.parse(SM.decrypt(value, interface_prikey1))
                console.log('登录用户信息获取-解密:', de_value)
                if (de_value.code == 200 && de_value.success) {
                  that.userInfo = de_value.data
                  that.$store.dispatch('user/updateUserInfo', de_value.data)
                  console.log("用户信息userInfo:", that.userInfo)
                  localStorage.setItem('complaintPersonInfo', JSON.stringify(that.userInfo.persons[0]));
                  console.log('用户信息获取完成')
                  console.log('自动登录调用完成')
                } else {
                  that.$dialog.alert({
                    type: 'danger',
                    // message: "对不起，您没有权限访问此应用，请联系荣成河湖湾长制管理员获取访问权限。",
                    message: de_value.message,
                    // confirmButtonText: '确认'
                  }).then(() => {
                    // this.$router.go(-1)
                    // oncloseWindow()
                    lightAppJssdk.navigation.close({
                      success: function (data) {
                        //成功回调
                      }, fail: function (data) {
                        //错误返回
                      }
                    });
                  })
                }
              } catch (error) {
                console.error("getLoginUser方法中try-catch error：", error)
                that.getLoginUser()
              }

            }
          })
        } else {
          const res = await get('/passport/getLoginUser')
          console.log('登录用户信息获取:', res)
          if (res.code == 200 && res.success) {
            this.userInfo = res.data
            this.$store.dispatch('user/updateUserInfo', res.data)
            console.log("用户信息userInfo:", this.userInfo)
            localStorage.setItem('complaintPersonInfo', JSON.stringify(this.userInfo.persons[0]));
            console.log('用户信息获取完成')
            console.log('自动登录调用完成')
          } else {
            this.$toast.fail(res.message || '登录用户信息获取失败')
          }
        }
      } catch (error) {
        // this.$toast.fail(error.message || '登录用户信息获取失败')
        console.log("getLoginUser方法外层catch报错error：", error)
        this.getLoginUser()
      }
    },
    newGetUserInfo() {
      console.log("开始执行newGetUserInfo方法1");
      let that = this
      try {
        lightAppJssdk.user.getUserInfoWithEncryptedParamByAppId({
          appId: "rcsdsjzxsfrzdjqwscouque", // 接入方在成功创建应用后自动生成
          success: function (data) {
            if (data == '未登录')
              that.onLoginApp()
            else {
              if (typeof data == 'string')
                data = JSON.parse(data)
              console.log("开始执行newGetUserInfo方法2");
              try {
                // 对于该方法的返回结果,需要进行两步解密才能得到明文用户信息,
                // 先对返回结果进行sm2解密,需要用到 接入方在创建应用时,选择应用的加密方式为sm2,并成功创建应用后,拿到的应用私钥来进行解密
                const sm2_privateKey = '009541094ecb28814131e7f8d3ca8f6279638cfd7dbbe6987505a3edd63b7e0888'
                let sm2_encrypt_result = data.data
                let sm2_decrypt_result = SM.decrypt(sm2_encrypt_result, sm2_privateKey)

                if (typeof sm2_decrypt_result == 'string')
                  sm2_decrypt_result = JSON.parse(sm2_decrypt_result)

                // 其次,对sm2解密后的结果进行 aes解密
                // aes解密需要用到 appword , 为固定值,使用示例代码中的即可
                let aes_encrypt_result = sm2_decrypt_result.data
                let aes_decrypt_result = aes_Decrypt(aes_encrypt_result, "aKd20dbGdFvmuwrt")

                // console.log("解密前：", JSON.stringify(data))
                // console.log("解密后：", aes_decrypt_result)
                console.log("用户信息：", JSON.parse(aes_decrypt_result))
                // that.card = JSON.parse(aes_decrypt_result).papersnumber

                that.userInfo = JSON.parse(aes_decrypt_result);
                that.autoLogin(that.userInfo.mobile)
                sessionStorage.setItem('isdUserInfo', JSON.stringify(that.userInfo))
              } catch (error) {
                that.newGetUserInfo()
                console.error("newGetUserInfo报错：", error);
              }
            }
          },
          fail: function (data) {

          }
        });
      } catch (error) {
        console.error("爱山东获取用户信息失败error：", error)
        that.newGetUserInfo()
      }

    },
    getIsdTicket: function () {
      let self = this;
      return new Promise((res, rej) => {
        lightAppJssdk.user.getTicket({
          success: function (result) {
            //成功回调
            self.ticketRes = result;
            console.log("getIsdTicket的返回值:", result)
            // 如果未登录激活登录窗口，确认激活，取消无操作
            if (result == "未登录") {
              lightAppJssdk.user.loginapp({
                success: function (data) {
                  //成功回调
                  window.location.reload();
                },
                fail: function (data) {
                  //错误返回
                },
              });
            } else {
              let ticket = JSON.parse(JSON.parse(result).data).ticket;
              self.ticket = ticket;
              console.log("爱山东用户ticket", ticket)
              self.newGetUserInfo()
            }
          },
          fail: function (result) {
            //错误返回
            alert("获取票据失败");
          },
        });
      });
    },
    /**
     * 使用jssdk调用登录页面
     */
    onLoginApp() {
      let that = this
      lightAppJssdk.user.loginapp({
        success: function (data) {
          if (data == "未登录") {
            //取消登录或登录失败，关闭页面
            oncloseWindow()
          } else {
            that.getIsdTicket()
          }
        },
        fail: function (data) {
          //关闭页面
          oncloseWindow()
        }
      })
    },
    oncloseWindow() {
      lightAppJssdk.navigation.close({
        success: function (data) {
          //成功回调
        }, fail: function (data) {
          //错误返回
        }
      });
    }
  },
  created() {
    console.log('开始自动登录...')
    try {
      if (appOrPC) {
        let that = this
        // this.getIsdTicket()
        // this.newGetUserInfo()

        window.addEventListener('message', (event) => {
          console.log("App.vue中的event")
          console.log("origin:", event.origin);
          console.log("data:", event.data);
          console.log("mobile:", event.data.isdUserInfo.mobile);
          // if (event.origin !== 'https://父页面域名') return;
          // console.log('接收数据:', event.data);
          that.autoLogin(event.data.isdUserInfo.mobile)
        });



      } else {
        // 使用固定账号和密钥登录
        const account = '18000000003'
        console.log('账号:', account)
        this.autoLogin(account)
      }
    } catch (error) {
      console.error('自动登录失败:', error)
    }
  },
  mounted() {

  }
}
// aes解密
function aes_Decrypt(word, key) {
  var key = CryptoJS.enc.Utf8.parse(key) //转为128bit
  var srcs = CryptoJS.enc.Hex.parse(word) //转为16进制
  var str = CryptoJS.enc.Base64.stringify(srcs) //变为Base64编码的字符串
  var decrypt = CryptoJS.AES.decrypt(str, key, {
    mode: CryptoJS.mode.ECB,
    spadding: CryptoJS.pad.Pkcs7
  })
  return decrypt.toString(CryptoJS.enc.Utf8)
}
</script>
